import { getRegistrationPathIdOrNull, getRegistrationPathIdOrDefault
} from '../redux/selectors/currentRegistrationPath';
import { isInviteePendingApproval, isInviteeApprovalDenied, isInviteeCancelled } from '../redux/persona';
import {
  APPROVAL_DENIED,
  PENDING_APPROVAL,
  POST_REGISTRATION
} from '../redux/website/registrationProcesses';
import { loadRegistrationContent } from '../redux/actions';
import { getIn } from 'icepick';
import { getDefaultWebsitePageId } from '../redux/website';
function getConfirmationPageId(state) {
  return getIn(state, ['website', 'pluginData', 'registrationProcessNavigation', 'registrationPaths',
    getRegistrationPathIdOrDefault(state), 'confirmationPageId']);
}

export const getConfirmationPageIdForInvitee = () => {
  return async (dispatch, getState) => {
    let pageId;
    if (isInviteePendingApproval(getState())) {
      await dispatch(loadRegistrationContent(PENDING_APPROVAL, getRegistrationPathIdOrNull(getState())));
      pageId = PENDING_APPROVAL.forCurrentRegistrant().startPageId(getState());
    } else if (isInviteeApprovalDenied(getState())) {
      await dispatch(loadRegistrationContent(APPROVAL_DENIED, getRegistrationPathIdOrNull(getState())));
      pageId = APPROVAL_DENIED.forCurrentRegistrant().startPageId(getState());
    } else if (isInviteeCancelled(getState())) {
      pageId = getDefaultWebsitePageId(getState()) || 'summary';
    } else {
      await dispatch(loadRegistrationContent(POST_REGISTRATION, getRegistrationPathIdOrNull(getState())));
      pageId = getConfirmationPageId(getState());
    }
    return pageId;
  };
};

export const getPostRegPageGroupPagesForInvitee = (state, translate) => {
  const { website: { pages } } = state;

  const pageIds = [];
  if (isInviteePendingApproval(state)) {
    const id = PENDING_APPROVAL.forCurrentRegistrant().startPageId(state);
    if (id) {
      pageIds.push(id);
    }
  } else if (isInviteeApprovalDenied(state)) {
    const id = APPROVAL_DENIED.forCurrentRegistrant().startPageId(state);
    if (id) {
      pageIds.push(id);
    }
  } else {
    pageIds.push(...POST_REGISTRATION.forCurrentRegistrant().pageIds(state));
  }

  return pageIds.map(id => {
    return {
      ...pages[id],
      name: translate(pages[id].name)
    };
  });
};
